import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { Dismissable } from "./concerns/dismissable"
import { ShowHide } from "./concerns/showHide"
import { usePwaHelpers } from "./concerns/use_pwa_helpers"

export default class extends Controller {

  initialize() {
    Loggable(this, {debug: false})
    Dismissable(this, {expiration: 30})
    ShowHide(this, {hiddenClassName: "d-none"})
    usePwaHelpers(this)
  }

  connect() {
    this.log("connected")
    this.installStateUnsubscribe = this.onInstallStateChange(() => this.render())
    this.render()
  }

  disconnect() {
    this.installStateUnsubscribe?.()
  }

  render() {
    if (!this.canInstall()) {
      this.log("cannot install")
      this.hide(this.element)

      if (this.isIosNative()) {
        this.log("is native")
        this.setInstalledCss()
      }

      return
    }

    if (this.getInstallState() === "installed") {
      this.log("is installed")
      this.hide(this.element)
      this.setInstalledCss()
      return
    }

    if (this.wasDismissed()) {
      this.log("said not now")
      this.hide(this.element)
      return
    }

    this.show(this.element)
  }

  setInstalledCss() {
    //let root = document.querySelector(":root")
    //root.style.setProperty("--tap-bar-height", "100px")
    //root.style.setProperty("--tap-bar-padding-top", "5px")
  }
}
